import React from 'react';

const A = ({href, className, children, to}) => (
    <a href={to ? to : href} className={className} target="_blank" rel="noopener noreferrer">
        {children}
    </a>
)

export default A;